import { useToast } from '@lifebit-ai/lds'
import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { ApiErrorResponse } from 'services/types'

import { deleteResultLabel } from '..'
import { DeleteResultLabelParams } from '../types'

/** mutation-cache: synced by the caller (useResults onSuccess): labels, result details and activity queries */
export const useDeleteResultLabel = (
  resultId: string,
  options?: Omit<UseMutationOptions<void, ApiErrorResponse, DeleteResultLabelParams>, 'mutationFn'>
) => {
  const toast = useToast()

  return useMutation<void, ApiErrorResponse, DeleteResultLabelParams>({
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to remove label'), type: 'error' })
    },
    ...options,
    mutationFn: params => deleteResultLabel(resultId, params)
  })
}
